module.exports = __webpack_public_path__ + "static/media/Arrow-down-green.33557edd.svg";